// Shared sample data for the brokerage marketing-services mockup.
// Persona: Agent "Bob Carter"

// ─────────────────────────────────────────────────────────────────────────────
//  BRAND — SINGLE SOURCE OF TRUTH
//  Swap the brokerage for any future demo by editing ONLY this object.
//  The logo, name, and accent color flow through every screen automatically.
// ─────────────────────────────────────────────────────────────────────────────
export const BRAND = {
  /** Brokerage display name — used in headers, footers, and copy. */
  name: "Berkshire Hathaway HomeServices Fox & Roach, REALTORS",
  /** Shorter name for tight spaces (mobile headers, badges). */
  shortName: "BHHS Fox & Roach",

  /** Logos. Full-color/dark logo for light backgrounds; mono for tight spots. */
  logo: {
    /** Primary logo shown on light surfaces (top bars, tracker header). */
    primary: "https://cdn.magicpatterns.com/uploads/g2PjVwT9e5eVsqz7a2dE6T/BHHS-FoxRoach-Logo_1Line_Black.png",
    /** Stacked / 2-line variant for larger brand moments. */
    stacked: "https://cdn.magicpatterns.com/uploads/3L1GojEUdLFsd3rTMESpMw/BHHS-FoxRoach-Logo_2Line-Cab.png",
  },

  /** Accent color (brand primary). Everything themed uses these three values. */
  accent: "#6C1D45", // BHHS Cabernet
  accentSoft: "#F3E7EE", // tinted background for soft banners/badges
  accentText: "#6C1D45", // text on soft backgrounds
} as const;

export const AGENT = {
  firstName: "Bob",
  fullName: "Bob Carter",
  initials: "BC",
  avatar: "https://cdn.magicpatterns.com/patterns/generated-images/e8239d35-ac05-4639-9b08-e6026ec7be42.jpg",
  /** @deprecated Use BRAND.name — kept for backwards compatibility. */
  brokerage: BRAND.name,
};

export type Listing = {
  id: string;
  address: string;
  type: string;
  price: string;
  listedAgo: string;
  hero: string;
  photos: string[];
  hasMarketing: boolean;
};

export const ELM: Listing = {
  id: "elm",
  address: "12 Elm Street",
  type: "Colonial",
  price: "$825,000",
  listedAgo: "Listed 3 days ago",
  hero: "https://cdn.magicpatterns.com/patterns/generated-images/144ad8dc-f636-49d3-8ebc-c72736d3f14c.jpg",
  photos: [
    "https://cdn.magicpatterns.com/patterns/generated-images/144ad8dc-f636-49d3-8ebc-c72736d3f14c.jpg",
    "https://cdn.magicpatterns.com/patterns/generated-images/f8f662e7-d0c3-4ba7-9686-65b6cb10f1b1.jpg",
    "https://cdn.magicpatterns.com/patterns/generated-images/fa27f134-323b-4d1b-8fc1-a31e9ee271a6.jpg",
    "https://cdn.magicpatterns.com/patterns/generated-images/b1d316d8-35fc-471a-b273-554c7bb1b4a9.jpg",
  ],
  hasMarketing: true,
};

export const MAIN: Listing = {
  id: "main",
  address: "123 Main Street",
  type: "Ranch",
  price: "$540,000",
  listedAgo: "Listed 2 weeks ago",
  hero: "https://cdn.magicpatterns.com/patterns/generated-images/3ce751af-f0e2-4dae-8aba-71404bf587d5.jpg",
  photos: [
    "https://cdn.magicpatterns.com/patterns/generated-images/3ce751af-f0e2-4dae-8aba-71404bf587d5.jpg",
  ],
  hasMarketing: false,
};

export const LISTINGS = [ELM, MAIN];

// Accent color used across the product — re-exported from BRAND so existing
// imports keep working while BRAND stays the single source of truth.
export const ACCENT = BRAND.accent;
export const ACCENT_SOFT = BRAND.accentSoft;
export const ACCENT_TEXT = BRAND.accentText;
